import { api } from './api';

export interface OrderProduct {
  id: number;
  name: string;
  sku: string;
  price: number;
  description?: string;
  sale_price?: number;
  shipping_price?: number;
  total: number;
  image?: string | null;
  parceled?: 'parceled' | 'vista' | null;
  canceled_at?: string | null;
}

export interface OrderCustomer {
  id: number | null;
  name: string | null;
  email: string | null;
  document: string | null;
  phone: string | null;
  address: any | null;
}

export interface OrderPaymentDetail {
  value: number | null;
  type: string | null;
}

export interface OrderPayment {
  gateway: string;
  payment1: OrderPaymentDetail;
  payment2: OrderPaymentDetail;
  payment3: OrderPaymentDetail;
  payment4: OrderPaymentDetail;
}

export interface OrderDetails {
  id: number;
  customer: OrderCustomer;
  salesman: {
    id: number | null;
    name: string | null;
  };
  status: {
    id: number;
    name: string;
  };
  products: OrderProduct[];
  shipping: any;
  shipping_total: number;
  subtotal: number;
  total: number;
  created_at: {
    human: string;
    timestamp: string;
  };
  updated_at: {
    human: string;
    timestamp: string;
  };
  payment_date: string | null;
  shipping_date: string | null;
  shipping_code: string | null;
  discount?: number;
  discount_code?: string | null;
  payment: OrderPayment;
}

export const ordersService = {
  getOrders: async (page = 1, search = '', limit = 15, filters: Record<string, any> = {}) => {
    const response = await api.get('/api/admin/orders', {
      params: {
        page,
        per_page: limit,
        search,
        ...filters
      }
    });
    return response.data;
  },

  getOrderById: async (id: number | string) => {
    const response = await api.get(`/api/admin/orders/${id}`);
    return response.data;
  },

  updateOrder: async (id: number | string, data: any) => {
    const response = await api.put(`/api/admin/orders/${id}`, data);
    return response.data;
  },

  cancelOrder: async (id: number | string) => {
    const response = await api.put(`/api/admin/orders/${id}/cancel`);
    return response.data;
  },

  cancelProduct: async (orderId: number | string, productId: number | string, returnToStore: boolean) => {
    const response = await api.post('/api/admin/orders/product/cancel', {
      order: orderId,
      product: productId,
      return: returnToStore ? 1 : 0
    });
    return response.data;
  },

  updateTracking: async (id: number | string, shippingCode: string) => {
    const response = await api.patch(`/api/admin/orders/${id}/track`, {
      shipping_code: shippingCode
    });
    return response.data;
  }
};
